module.exports = __webpack_public_path__ + "static/media/mou-dhe.e16b9037.jpeg";